import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

function applyDarkClass() {
  document.documentElement.classList.add('dark');
}

export function ThemeProvider({ children }) {
  useEffect(() => {
    applyDarkClass();
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
